import React from 'react';

import { Box } from '@mui/material';

const IconBannedUser = ({ className = null }) => {
  return (
    <svg
      className={className}
      height="40"
      viewBox="0 0 40 40"
      width="40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="background" x1="0%" x2="0%" y1="0%" y2="100%">
          <Box
            component="stop"
            offset="0%"
            sx={(theme) => ({ stopColor: theme.tokens.bannedColorLight })}
          />
          <Box
            component="stop"
            offset="100%"
            sx={(theme) => ({ stopColor: theme.tokens.bannedColorDark })}
          />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <circle cx="20" cy="20" fill="url(#background)" r="20" />
        <Box
          component="circle"
          cx="20"
          cy="20"
          r="13"
          strokeWidth="3"
          sx={(theme) => ({ stroke: theme.tokens.matterColorLight })}
        />
        <Box
          component="path"
          d="M28.34 9.04l2.12 2.12-19.8 19.8-2.12-2.12z"
          sx={(theme) => ({ fill: theme.tokens.matterColorLight })}
        />
      </g>
    </svg>
  );
};

export default IconBannedUser;
